import { ReactNode } from "react";
import { Pencil } from "lucide-react";
import { Button } from "~/components/ui/button";

interface EditableIconProps {
  icon: ReactNode;
  canEdit: boolean;
  // Opens the caller's appearance-edit dialog. The dialog itself is entity-specific,
  // so it stays with the caller — this component only renders the hover trigger.
  onEdit: () => void;
}

/**
 * Icon/avatar block shared by the project / dataset / agent overview pages: a
 * pencil appears on hover over the icon and opens the caller's appearance dialog.
 */
export function EditableIcon({ icon, canEdit, onEdit }: EditableIconProps) {
  return (
    <div className="group relative">
      {icon}
      {canEdit && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute -bottom-1 -right-1 size-6 rounded-full bg-background opacity-0 shadow transition-opacity group-hover:opacity-100"
          aria-label="Edit appearance"
          onClick={onEdit}
        >
          <Pencil className="size-3" />
        </Button>
      )}
    </div>
  );
}
